import { Zap } from 'lucide-react';
import { GuideCategory } from './types';

export const socialSharingGuide: GuideCategory = {
  id: 'social-and-sharing',
  title: 'Social & Viral Sharing',
  icon: Zap,
  articles: [
    {
      slug: 'viral-sharing-tips',
      title: 'Going Viral with Ball Bouncing',
      description: 'Best practices for sharing your ball simulations on social media.',
      sections: [
        {
          id: 'tiktok-reels',
          title: 'Optimizing for TikTok & Reels',
          content: 'Our ball engine is designed to create highly "satisfying" content that performs well on vertical platforms. Use the "Vertical Ratio" setting in the Studio for the best results.',
          tips: ['Record your ball bouncing simulator at 60FPS for the smoothest visual impact.']
        },
        {
          id: 'youtube-shorts',
          title: 'Exporting for YouTube',
          content: 'When exporting for YouTube, ensure your audio is crisp. Our high-fidelity export options preserve the perfect sync between the ball physics and the sound.'
        }
      ]
    }
  ]
};
